<template>
  <div
    v-if="isLoading"
    class="loading-global-box"
  >
    <LoadingIcon size="lg" :isLoading="true" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    components: {
      LoadingIcon,
    },
    computed: {
      ...mapGetters('app', ['isLoading'])
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .loading-global-box {
    top: 0;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: $purple900;
    z-index: 100;
  }
</style>